export default __webpack_public_path__ + "static/media/IMG_2557.37f00dfc.PNG";